import type { ReactNode } from 'react'
import { createContext, useContext, useEffect, useState } from 'react'
import { api } from './api'

export interface AppConfig {
  prices_enabled: boolean
  features: { export_csv: boolean }
  disclaimer: string
}

const DEFAULT: AppConfig = {
  prices_enabled: false,
  features: { export_csv: false },
  disclaimer: 'Information on corporate filings only. Not a recommendation to buy or sell.',
}

const ConfigContext = createContext<AppConfig>(DEFAULT)

export const CONFIG_CHANGED = 'bceie:config'

/** Runtime config from /api/v2/config (prices licence, feature switches). */
export function ConfigProvider({ children }: { children: ReactNode }) {
  const [cfg, setCfg] = useState<AppConfig>(DEFAULT)
  useEffect(() => {
    const load = () => { api<AppConfig>('/config').then(setCfg).catch(() => undefined) }
    load()
    // The admin console fires this after changing a runtime switch (e.g. live rates).
    window.addEventListener(CONFIG_CHANGED, load)
    return () => window.removeEventListener(CONFIG_CHANGED, load)
  }, [])
  return <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>
}

export const useConfig = () => useContext(ConfigContext)
